module.exports = __webpack_public_path__ + "img/Supermarket-Thermal.63a72f92.jpg";